import styled, { css } from 'styled-components';


export const Wrapper = styled.div`
  ${({ theme, $visible, $isFullScreen }) => css`
    font-family: ${theme.v2.font.family.primary};
    background-color: ${theme.v2.colors.neutral.highPure};
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 100vh;
    justify-content: space-between;
    max-width: 480px;
    padding: 0px 20px 0px;
    position: fixed;
    right: ${$visible ? '0px' : '-480px'};
    top: 0px;
    transition: right 350ms ease-in-out;
    width: 100%;
    z-index: ${theme.v2.layers.awaysOnTop};
    max-height: 100%;

    ${$isFullScreen && css`
      margin: auto;
    `}
  `}
`;

export const FullScreenWrapper = styled.div`
  display: flex;
  height: 100%;
`;

export const FullScreenChatContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    height: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 0;
    }
  `}
`;

export const ChatContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 100vh;
    overflow: hidden;
    width: 100%;
    padding: 0px 20px 20px;
    max-height: 100%;
    z-index: ${theme.v2.layers.awaysOnTop};
  `}
`;

export const Header = styled.div`
  ${({ theme, $isFullScreen }) => css`
    padding: ${$isFullScreen ? '16px 20px' : '16px 0px'};
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    font-family: ${theme.v2.font.family.primary};
    color: ${theme.v2.colors.neutral.lowDark};
    font-weight: ${theme.v2.font.weights.medium};
    font-size: ${theme.v2.font.sizes.xxs};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const FormWrapper = styled.div`
  ${({ $isFullScreen }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    ${$isFullScreen && css`
      margin: 0px 20px;
      max-width: 880px;
    `}
  `};
`;

export const Form = styled.form`
  ${({
    theme, $disabled, $isFullScreen, $moreThanOneLine,
  }) => css`
    border-radius: 24px;
    border: 1px solid  ${theme.v2.colors.neutral.highMedium};
    box-shadow: 2px 2px 8px 0px rgba(147, 147, 147, 0.16);
    display: flex;
    flex-direction: column;
    margin-top: auto;
    padding: 20px 12px 12px 20px;
    width: 100%;

    &:focus-within {
      border: 1px solid ${theme.v2.colors.brand.primaryBlue};
    }

    ${$disabled && css`
      background-color: ${theme.v2.colors.neutral.highLight};
      border: 1px solid ${theme.v2.colors.neutral.highLight};
      cursor: not-allowed;
    `}

    ${$isFullScreen && css`
      margin: 0px 20px;
      max-width: 800px;
    `}

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      flex-direction: ${$moreThanOneLine ? 'column' : 'row'};
      justify-content: space-between;
      padding: 20px 16px;
    }
  `}
`;

export const AudioButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const RecordButton = styled.button`
  background-color: red;
  color: white;
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  cursor: pointer;
`;

export const StopButton = styled.button`
  background-color: gray;
  color: white;
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  cursor: pointer;
`;

export const SendAudioButton = styled.button`
  background-color: green;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
`;

export const VolumeVisualizer = styled.div`
  display: flex;
  align-items: flex-end;
  width: 50px;
  height: 50px;
  background-color: #f0f0f0;
  border-radius: 5px;
  overflow: hidden;
`;

export const VolumeBar = styled.div`
  width: 100%;
  background-color: blue;
  transition: height 0.1s ease;
`;

export const RoundedButton = styled.button`
  ${({ theme, $hideInMobile, $canShowButton }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 100%;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    cursor: pointer;
    display: flex;
    height: 36px;
    justify-content: center;
    margin-left: auto;
    positiion: relative;
    width: 36px;

    ${$hideInMobile && css`
      @media (max-width: ${theme.v2.breakpoints.md}) {
        display: none;
      }
    `}

    ${!$canShowButton && css`
      display: none;
    `}
  `}
`;

export const SeverityDot = styled.span`
  ${({ $severity, theme }) => {
    const colors = {
      critical: {
        bgColor: theme.v2.colors.feedback.problemPure,
        shadow: `drop-shadow(0 0 5px ${theme.v2.colors.feedback.problemPure});`,
      },
      warning: {
        bgColor: theme.v2.colors.feedback.attentionPure,
        shadow: `drop-shadow(0 0 5px ${theme.v2.colors.feedback.attentionPure});`,
      },
    };

    return css`
    width: 8px;
    height: 8px;
    border-radius: 100%;
    background-color: ${colors[$severity].bgColor};
    filter: ${colors[$severity].shadow};
    position: absolute;
    top: 6px;
    right: 6px;
  `;
  }}
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;
  width: fit-content;
  align-self: end;
  `;

export const RoundedButtonForcedCenter = styled(RoundedButton)`
  ${({ $shouldForceCenter }) => css`
    svg {
      flex: 0 0 16px;
      margin: ${$shouldForceCenter && '2px 0px 0px 2px'};
    }
  `};
`;

export const SubmitWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    height: 36px;
    margin-left: auto;
    width: 36px;

    button {
      border-radius: 100%;
      height: 36px;
      padding: 0px;
      width: 36px;

      &:disabled {
          background-color: ${theme.v2.colors.neutral.highMedium};
      }
    }
  `}
`;

export const TextArea = styled.textarea`
  ${({ theme }) => css`
    height: 34px;
    max-height: 200px;
    border: 0px;
    resize: none;
    outline: none;
    overflow-y: auto;
    placeholder: ${theme.v2.colors.neutral.highMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    color: ${theme.v2.colors.neutral.lowDark};

    &:disabled {
      background-color: ${theme.v2.colors.neutral.highLight} !important;
      cursor: not-allowed;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      height: 34px;
      min-height: auto;
    }
  `}
`;

export const SlideInButton = styled.button`
  ${({ theme, $visible }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.brand.primaryMedium};
    border-radius: 24px 24px 0px 0px;
    border: unset;
    color: ${theme.v2.colors.neutral.highPure};
    cursor: pointer;
    display: flex;
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    gap: 8px;
    justify-content: center;
    line-height: ${theme.v2.font.lineHeight.text};
    opacity: ${$visible ? '1' : '0'};
    padding: 16px 24px;
    position: fixed;
    right: -31px;
    top: 48vh;
    transform: rotate(-90deg);
    transition: opacity 350ms ease-in-out, pointer-events 350ms ease-in-out;
    visible: ${$visible ? 'visible' : 'hidden'};
    z-index: ${theme.v2.layers.awaysOnTop};
  `}
`;

export const MaiaIcon = styled.img`
  ${({ $marginTop }) => css`
    height: 24px;
    margin: ${$marginTop ? '-2px 0px 0px 0px' : '16px 0px 0px'};
    width: 24px;
    border-radius: 100%;
  `}
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-left: auto;
`;

export const RatingSurveyWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SuveryRow = styled.div`
  ${({ $fullScreen }) => css`
      display: inline-block;
      margin: ${$fullScreen ? '12px auto 20px' : '0 auto 20px'};
      max-width: ${$fullScreen ? '100%' : '297px'};
      text-align: center;
  `}
`;

export const SurveyLabel = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.regular};
  `}
`;

export const SurveyCta = styled(SurveyLabel)`
    ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryMedium};
    cursor: pointer;
    font-weight: ${theme.v2.font.weights.medium};
  `}
`;

export const Disclaimer = styled.div``;
